// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"42017c54","81":"3ee2e420","413":"f349ad89","415":"f19a0c77","665":"8b3cd35f","972":"c1b28c2b"}[chunkId] + ".chunk.js";
};